"use client";

import { useEffect } from "react";

export function DeferredVercelAnalytics() {
  useEffect(() => {
    let active = true;

    void import("@vercel/analytics")
      .then(({ inject }) => {
        if (!active) return;
        inject({
          framework: "next",
          basePath: process.env.NEXT_PUBLIC_VERCEL_OBSERVABILITY_BASEPATH,
        });
      })
      .catch(() => {
        // Analytics must never affect page behavior.
      });

    return () => {
      active = false;
    };
  }, []);

  return null;
}
